import axios from "@/api/axiosInstance";

export function createTemplate(payload) {
  return axios.post(`/api/v1/templates`, payload);
}

export function fetchTemplates(pageNumber) {
  return axios.get(`/api/v1/templates?page=${pageNumber}`);
}

export function updateTemplate(payload) {
  return axios.patch(`/api/v1/templates/${payload.id}`, payload.values);
}

export function deleteTemplate(payload) {
  return axios.delete(`/api/v1/templates/${payload}`);
}
